"use client";
import { useEffect } from "react";
import { useAuth } from "@/app/context/AuthContext";
import { useRouter, usePathname } from "next/navigation";

export default function ProtectedContent({ children }: { children: React.ReactNode }) {
    const { isLoggedIn, isAuthReady } = useAuth();
    const router = useRouter();
    const pathname = usePathname();

    const publicRoutes = ["/login", "/register"];

    useEffect(() => {
        if (isAuthReady && !isLoggedIn && !publicRoutes.includes(pathname)) {
            router.replace("/login");
        }
    }, [isAuthReady, isLoggedIn, pathname, router]);

    if (!isAuthReady) return null;
    if (!isLoggedIn && !publicRoutes.includes(pathname)) return null;

    return <>{children}</>;
}